import React, { useState } from 'react';

import RibbonButton from 'common/components/button/RibbonButton';
import { EditOutlined } from '@ant-design/icons';

import AddHierarchyModal from '../../modal/product-hierarchy/AddHierarchyModal';

import Messages from 'i18n/messages/home';

const EditHierarchy = (props) => {
  const { selectedHierarchy, sectionDisabled } = props;

  const [visible, setVisible] = useState(false);

  const onClickHandler = () => {
    setVisible(true);
  };

  const isDisabled = !selectedHierarchy || sectionDisabled;

  return (
    <>
      <RibbonButton
        size='small'
        className='button-item-dropdown'
        icon={<EditOutlined style={{ height: 26 }} />}
        label={Messages.editHierarchy}
        onClick={onClickHandler}
        disabled={isDisabled}
      />
      <AddHierarchyModal
        visible={visible}
        setVisible={setVisible}
        selectedHierarchy={selectedHierarchy}
        isEdit
      />
    </>
  );
};

export default EditHierarchy;
